import React from 'react'
import classes from './TitleBox.scss'

export const TitleBox = ({ title, children }) => {
  return <div className={classes.box}>
    <h4 className={classes.title}>{title}</h4>
    <div>
      {children}
    </div>
  </div>
}

export default TitleBox



/** WEBPACK FOOTER **
 ** ./src/components/Common/TitleBox/TitleBox.js
 **/